import classNames from 'classnames';
import React from 'react';

import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import QuantityInput from 'common/components/QuantityInput';
import { TranslatedMessage } from 'common/components/Intl';

export default class VariantPendingQuantityInput extends React.Component {
  static propTypes = {
    className: propTypes.string,
    defaultQuantity: propTypes.number,
    order: accountPropTypes.OrderWithLineItems.isRequired,
    variant: accountPropTypes.ProductVariant.isRequired,
    quantityPending: propTypes.number.isRequired,
    quantitySaved: propTypes.number.isRequired,
    isSoldOut: propTypes.bool,
    maximum: propTypes.number,
  };

  static defaultProps = {
    defaultQuantity: 0,
    maximum: Infinity,
  };

  updateQuantity = quantity => {
    quantity = this.props.quantitySaved + quantity;
    this.props.changeVariantQuantity(
      this.props.variant,
      this.props.offeringId,
      quantity
    );
  };

  render() {
    const {
      className,
      defaultQuantity,
      quantityPending,
      quantitySaved,
      maximum,
      variant,
      isCommitmentReward,
      isSoldOut = false,
    } = this.props;
    const value = isSoldOut ? 0 : quantityPending - quantitySaved;
    const readOnly = isCommitmentReward || isSoldOut || false;

    if (variant.retailExclusive) {
      return (
        <p className="text center">
          <TranslatedMessage
            id={'cart.variant_pending_quantity_input.exclusive_retailers'}
          />
        </p>
      );
    }
    return (
      <QuantityInput
        className={classNames('VariantPendingQuantityInput', className)}
        defaultQuantity={defaultQuantity}
        onChange={this.updateQuantity}
        readOnly={readOnly}
        value={value}
        maximum={maximum}
      />
    );
  }
}
